function AdminModal({ title, onClose, children }) {
  return (
    <div className="admin-modal" role="presentation" onClick={onClose}>
      <div
        className="admin-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="admin-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h2 id="admin-modal-title" className="admin-modal__title">
            {title}
          </h2>
          <button type="button" className="admin-modal__close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="admin-modal__body">{children}</div>
      </div>
    </div>
  );
}

export default AdminModal;
